import { render, staticRenderFns } from "./EditPataModal.vue?vue&type=template&id=7d682290"
import script from "./EditPataModal.vue?vue&type=script&lang=js"
export * from "./EditPataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports